import { VehicleModelStateService } from './../../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';
import { isNullOrUndefined } from 'util';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import { FormControl } from '@angular/forms';
import { TextTransformService } from '../../../services/text-transform.service';
import {isCarOne, isMobile} from '../../../../core/utils/utils';
import { VehicleModelConsts } from '../../../../core/consts/vehicle-model.consts';
import {FormFieldService} from '../../../services/form-field.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FieldCaptionTarget} from '../../../models/field-config';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['text-field.component.scss']
})
export class TextFieldComponent extends AbstractFieldComponent implements OnInit, AfterViewInit {

  @ViewChild('dynamicSuffix') dynamicSuffix;
  suffixIcon: string;

  private _fieldMask;
  // private _maskPatterns = {};
  private _dropSpecialCharacters = false;
  private _fontContext: string;
  private _hasDynamicSuffix: boolean;
  private _sufix: string;
  private inputType: string = 'text';
  private isAmountTextTransform = false;
  private amountTextTransform = {
    value: ' ',
    regexp: /(\d)(?=(\d{3})+(?!\d))/g,
  };

  constructor(private elementRef: ElementRef,
              public formFieldService: FormFieldService,
              private vehicleModelStateService: VehicleModelStateService) {
    super(formFieldService);
  }

  public ngOnInit(): void {
    this.initFieldAppearance();
    this.initPlaceholderAndLabel();
    this.initSuffixIcon();
    this._hasDynamicSuffix = this.fieldConfig.properties && this.fieldConfig.properties.dynamicSuffix;
    this.isAmountTextTransform = this.fieldConfig.properties && this.fieldConfig.properties.textTransform && this.fieldConfig.properties.textTransform.type === 'amount';
    this.initInputType();

    if (this.isAmountTextTransform) {
      if (this.fieldConfig.properties.textTransform.separatorConfig) {
        this.amountTextTransform = {
          value: this.fieldConfig.properties.textTransform.separatorConfig.separator,
          regexp: new RegExp(`(\\d)(?=(\\d{${this.fieldConfig.properties.textTransform.separatorConfig.charsChain}})+(?!\\d))`, 'g'),
        }
      }
      this.handleAmountTextTransform(this.control.value);
    }
    this.handleStatusChanges();
  }

  ngAfterViewInit() {
    if (this.hasDynamicSuffix) {
      this.initFontContext();
      this.initSuffix();
    }
  }

  onTextFieldChange(event) {
    this.onChange(event);
    this.handleCustomChangeEvents();
  }

  get mask() {
    if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.mask) {
      this._fieldMask = this.fieldConfig.maskConfig.mask;
    }

    if ('errors' in this.control && this.control.errors != null && 'Mask error' in this.control.errors) {
      delete this.control.errors['Mask error'];
    }

    return this._fieldMask;
  }

  get dropSpecialCharacters() {
    if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.dropSpecialCharacters) {
      this._dropSpecialCharacters = this.fieldConfig.maskConfig.dropSpecialCharacters;
    }
    return this._dropSpecialCharacters;
  }

  get sufix() {
    if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.sufix) {
      this._sufix = this.fieldConfig.maskConfig.sufix;
    }
    return this._sufix;
  }

  get hasMobileInputType(): boolean {
    return this.fieldConfig.properties && this.fieldConfig.properties.mobileInputType;
  }

  get hasInputText(): boolean {
    return this.fieldConfig.properties && this.fieldConfig.properties.inputText;
  }

  // get patterns() {
  //   if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.patterns) {
  //     this._maskPatterns = this.fieldConfig.maskConfig.patterns;
  //   }
  //   return this._maskPatterns;
  // }

  get fontContext() {
    return this._fontContext;
  }

  get hasDynamicSuffix(): boolean {
    return this._hasDynamicSuffix;
  }

  // commented line is definition of original requirements for displaying verification hint
  get verificationHintVisible(): boolean {
    return false;
    // return this.isPredefinedValue;
  }

  onBlurWithMask(event) {
    this.sendFieldClickEvent();
    this.onChange(event);
    if (this.isAmountTextTransform) {
      this.handleValuesAfterDot();
    }
  }

  onBlurWithoutMask(event) {
    this.sendFieldClickEvent();
    this.onTextFieldChange(event);
    if (this.isAmountTextTransform) {
      this.handleValuesAfterDot();
    }
  }

  handleInputEvent(e) {
    if (this.isAmountTextTransform) {
      let { value: eventValue } = e.target;
      this.handleAmountTextTransform(eventValue);
      this.deleteInitialZero();

      if (e.inputType !== 'deleteContentBackward') {
        this.removeDotAfterFirstDot();
      }
    }
  }

  public changeValue(event): void {
    let value = event.target.value;
    this.updateSuffix(value, this.fieldConfig.fieldKey);
  }

  public updateSuffix(value, fieldKey) {
    if (this.hasDynamicSuffix) {
      let myDiv = this.elementRef.nativeElement.querySelector('#' + fieldKey + '-dynamic-suffix');
      const width = this.getTextWidth(value, fieldKey);
      myDiv.style.left = width + 5 + 'px';
    }
  }

  public getTextWidth(text, fieldKey) {
    let canvas = <HTMLCanvasElement> document.getElementById(fieldKey + '-canvas');
    let context = canvas.getContext('2d');
    context.font = this.fontContext;
    let metrics = context.measureText(text);
    return metrics.width;
  }

  private async sendFieldClickEvent() {
    if (this.fieldConfig && this.fieldConfig.analyticsConfig && this.fieldConfig.analyticsConfig.includeFieldValue) {
      const value = await this.valueLabel();
      this.formFieldService.onClick(this.fieldConfig, value);
    }
  }

  private removeDotAfterFirstDot() {
    if (this.control.value) {
      const index = this.control.value.indexOf('.');
      if (index >= 0) {
        const value = this.control.value.split('').map((letter, i) => {
          if (i <= index) {
            return letter;
          }

          if (letter === '.') {
            return ''
          }

          return letter;

        }).join('');
        this.control.setValue(value);
      }
    }
  }

  private deleteInitialZero() {
    if (this.control.value) {
      if (this.control.value.indexOf('0') === 0 && this.control.value.length > 1 && this.control.value[1] !== '.') {
        this.control.setValue(this.control.value.substr(1));
      }
    }
  }

  private handleAmountTextTransform(eventValue) {
    if (!eventValue) {
      return;
    }

    this.allowOnlyNumbers(eventValue);


    const {regexp, value} = this.amountTextTransform;
    let string = [...this.control.value].join('');
    string = string.replace(new RegExp(value, 'g'), '');
    if (string.indexOf(',') >= 0) {
      string = string.replace(/,/g, '.');
    }

    if (string.indexOf('.') >= 0) {
      let index = string.indexOf('.');
      string = string.substr(0, index + 3);
    }
    const result = string.replace(regexp, '$1' + value);
    this.control.setValue(result);
  }

  private allowOnlyNumbers(eventValue) {
    const regex = RegExp(/[^0-9 .,]+/, 'g');
    const onlyNumbers = eventValue.replace(regex, '');
    this.control.setValue(onlyNumbers);
  }

  private handleValuesAfterDot() {
    if (this.control.value.indexOf('.') >= 0) {
      const letterAfterDot = this.control.value[this.control.value.indexOf('.') + 1];
      const lastCharacter = this.control.value[this.control.value.indexOf('.') + 2];

      if (!letterAfterDot && this.control.value) {
        this.control.setValue(this.control.value + '00');
      }

      if (letterAfterDot && !lastCharacter) {
        this.control.setValue(this.control.value + '0');
      }
    } else {
      if (this.control.value) {
        this.control.setValue(this.control.value + '.00');
      }
    }
  }

  private initFontContext() {
    const inputElement = document.querySelector(`#${this.fieldConfig.fieldKey}Input`);
    const styleComputed = getComputedStyle(inputElement);
    this._fontContext = styleComputed.fontSize + ' ' + styleComputed.fontFamily;
  }

  private initSuffix() {
    if (!isNullOrUndefined(this.control.value)) {
      const separatorConfig = this.fieldConfig.properties.textTransform.separatorConfig;
      let value = TextTransformService.separateValues(this.control.value, separatorConfig);
      this.updateSuffix(value, this.fieldConfig.fieldKey);
    }
  }

  private initInputType(): void {
    if (isMobile() && this.hasMobileInputType) {
      this.inputType = this.fieldConfig.properties.mobileInputType;
    } else {
      if (this.hasInputText) {
        this.inputType = this.fieldConfig.properties.inputText;
      }
    }
  }

  private handleCustomChangeEvents(): void {
    switch (this.fieldConfig.fieldKey) {
      case VehicleModelConsts.REGISTRATION_NUMBER:
        this.vehicleModelStateService.registrationNumberEvent.emit(this.control.value);
    }
  }

  private initPlaceholderAndLabel(): void {
    if (isNotNullOrUndefined(this.fieldConfig.captionTarget)) {
      if (this.fieldConfig.captionTarget === FieldCaptionTarget.PLACEHOLDER) {
        this.placeholder = this.fieldConfig.caption;
      } else {
        this.label = this.fieldConfig.caption;
      }
    } else {
      if (this.isAppearanceOutline) {
        this.label = this.fieldConfig.caption;
      } else {
        this.placeholder = this.fieldConfig.caption;
      }
    }
  }

  private initSuffixIcon(): void {
    if (isCarOne()) {
      this.suffixIcon = './assets/images/icons/car-one-pencil.svg';
    }

    if (isNotNullOrUndefined(this.fieldConfig.suffixIcon)) {
      this.suffixIcon = this.fieldConfig.suffixIcon;
    }
  }
}

export function ValidateNotEqualZero(c: FormControl) {
  let NOT_EQUAL_ZERO_REGEXP = new RegExp('[^0]+');

  return NOT_EQUAL_ZERO_REGEXP.test(c.value) ? null : {
    notEqualZero: {
      valid: false
    }
  };
}
